const Econfig={
	pMschang:{
		//上拍量折线图
		drawCj:function(xData,yData,echart,distribution){
			let myChart = echart.init(document.getElementById('myChart'))
			//定义年身分数据
			const xv = xData;
			//定义实际数据
			const yd = yData;
			myChart.setOption({
				/* title: {
					text: this.getTitle(),
					textStyle: {
						fontSize: 18
					}
				}, */
				tooltip: {
					"trigger": "axis",
					"triggerOn": "click",
					"position": ['30%', '10%'],
					formatter(params) {
				        const item = params[0];
				        return `
				                ${item.axisValueLabel}
				                上拍量：${formatNum(item.data)}件
				               `;
				 	},
				},
				dataZoom: {
					show: true,
					realtime: true,
					y:20,
					height: 20,
					start:55,
					end:100,
					zoomLock:true
				},
				grid: {
					x: 40, //默认是80px
					y: 65, //默认是60px
					x2: 0, //默认80px
					y2:30,//默认60px
					bottom:'13%'
				},
				xAxis: {
					type: 'category',
					data: xv,
					axisTick: {length:5},
					axisLabel: {
						interval:1,
						rotate: 45,
					}
				},
				yAxis: {
					type: 'value',
					interval:distribution.distribution,
					min:distribution.min,
					max:distribution.max,
				},
				series: [{
					data: yd,
					type: 'line',
					itemStyle : {  
                        normal : {  
                            color:'#18BD6F'  
                        }  
                    }
				}]
			});
			window.addEventListener("resize", function() {
				setTimeout(function() {
					myChart.resize();
				}, 0)
			});
		},
		//拍卖价格分布图
		drawJg:function(yData,sData,echart,title,distribution){
			let mypmjg = echart.init(document.getElementById('mypmjg'))
			mypmjg.setOption({
				title: {
					text:title,
					top: '20px',
					textStyle: {
						fontSize: 16
					}
				},
				tooltip: {
					"trigger": "axis",
					"triggerOn": "click",
					"position": ['30%', '10%'],
					formatter(params) {
					    const item = params[0];
					    return `
					            ${item.name}
					            成交量：${formatNum(item.data)}件
					           `;
					 },
				},
				grid: {
					x: 90, //默认是80px
					y: 60, //默认是60px
					x2: 0, //默认80px
					y2: 0 //默认60px
				},
				yAxis: [{
					splitNumber: 8,
					type: 'category',
					data:yData,
					inverse: true,
					axisTick: {
						alignWithLabel: true,
					},
					axisLabel: {
						margin: 10,
						textStyle: {
							fontSize: 12,
							color: '#000'
						}
					}
				}],
				xAxis: [{
					show: false,
					type: 'value',
					axisLabel: {
						show: false
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: false
						
					},
					min:distribution.min,
					max:distribution.max+1000//需要最大值
				}],
				series: [{
					data:sData,
					type: 'bar',
					barWidth: 15,
					itemStyle: {
						normal: {
							color: '#42b983',
							label: {
								show: true,
								position: 'right',
								textStyle: {
									color: '#615a5a',
								}
							},
						}
					},
			
				}]
			});
			window.addEventListener("resize", function() {
				setTimeout(function() {
					mypmjg.resize();
				}, 0)
			});
		},
		//拍卖公司分布
		drawGs:function(lData,sData,echart,title){
			let mypmgs = echart.init(document.getElementById('mypmgs'))
			mypmgs.setOption({
				title: {
					text: title,
					top: '20px',
					textStyle: {
						fontSize: 16
					}
				},
				grid: {
					x: 0, //默认是80px
					y: 0, //默认是60px
					x2: 0, //默认80px
					y2: 60 //默认60px
				},
				tooltip: {
					trigger: 'item',
					formatter: "{b} 成交额占比：{c}%",
					"position": ['30%', '10%'],
				},
				legend: {
					orient: 'vertical',
					x: 'right',
					y: 'center',
					data:lData,
				},
				series: [{
					name: '访问来源',
					type: 'pie',
					radius: ['30%', '60%'],
					avoidLabelOverlap: false,
					center: ['35%', '55%'],
					label: {
						normal: {
							color:function(params) {
		                     //自定义颜色
		                     var colorList = [           
		                             '#ccc','#fcf','#ffc','#cff','#cfc',                                    
		                             '#ccf','#fcf'
		                         ];
		                         return colorList[params.dataIndex]
		                    },
							show: true,
							position: 'center',
							formatter: function() {
								return ''
							},
							textStyle: {
								fontSize: 40,
								color: 'green'
							}
						},
						emphasis: {
							show: false,
							textStyle: {
								fontSize: '30',
								fontWeight: 'bold'
							}
						}
					},
					labelLine: {
						normal: {
							show: false
						}
					},
					data:sData
				}]
			})
			window.addEventListener("resize", function() {
				setTimeout(function() {
					mypmgs.resize();
				}, 0)
			});
		},
		//成交量折线图
		drawCenter:function(xData,yData,echart,distribution,options){
			options = options||{};
			let myCjl = echart.init(document.getElementById('myCjl'));
			//定义年身分数据
			const xv = xData;
			//console.log(xv,"年份数据处理")
			//定义实际数据
			const yd = yData;
			let inverse = options.inverse ? { inverse: true}: {};
			console.log(inverse)
			myCjl.setOption({
				/* title: {
					text: '成交拍品分布123',
					textStyle: {
						fontSize: 18
					}
				}, */
				tooltip: {
					"trigger": "axis",
					"triggerOn": "click",
					"position": ['30%', '10%'],
					formatter(params) {
					       const item = params[0];
					       //console.log(item,789)
					       return `
					               ${item.axisValueLabel}
					               成交量：${formatNum(item.data)}件
					              `;
					},
				},
				dataZoom: {
					show: true,
					realtime: true,
					y: 20,
					height: 20,
					start: 75,
					end: 100,
					zoomLock:true
				},
				grid: {
					x: 40, //默认是80px
					y: 60, //默认是60px
					x2: 0, //默认80px
					y2: 30, //默认60px
					bottom:'13%'
				},
				xAxis: {
					type: 'category',
					data: xv,
					axisTick: {length:10},
					axisLabel: {
						interval:0,
						rotate: 40
					},
				
				
				},
				yAxis: {
					type: 'value',
					interval:distribution.distribution,
					min:distribution.min,
					max:distribution.max,
					...inverse
				},
				series: [{
					data: yd,
					type: 'line',
					itemStyle : {  
                        normal : {  
                            color:'#18BD6F'  
                        }  
                    }
				}]
			});
			window.addEventListener("resize", function() {
				setTimeout(function() {
					myCjl.resize();
				}, 0)
			});
		},
		//成交额折线图
		drawCje:function(xData,yData,echart,distribution){
			let myCje = echart.init(document.getElementById('myCje'));
			//定义年身分数据
			const xv = xData;
			//定义实际数据
			const yd = yData;
			myCje.setOption({
				/* title: {
					text: '成交拍品分布456',
					textStyle: {
						fontSize: 18
					}
				}, */
				tooltip: {
					"trigger": "axis",
					"triggerOn": "click",
					"position": ['30%', '10%'],
					formatter(params) {
					    const item = params[0];
					    return `
					            ${item.axisValueLabel}
					            成交额：${formatNum(item.data/100)}万元
					           `;
					 },
				},
				dataZoom: {
					show: true,
					realtime: true,
					y: 20,
					height: 20,
					start: 75,
					end: 100,
					zoomLock:true
				},
				grid: {
					x: 80, //默认是80px
					y: 60, //默认是60px
					x2: 0, //默认80px
					y2: 30,
					bottom:'13%'//默认60px
				},
				xAxis: {
					type: 'category',
					data: xv,
					axisTick: {length:10},
					axisLabel: {
						interval:0,
						rotate: 40
					}
				},
				yAxis: {
					type: 'value',
					interval:distribution.distribution,
					min:distribution.min,
					max:distribution.max,
				},
				series: [{
					data: yd,
					type: 'line',
					itemStyle : {  
                        normal : {  
                            color:'#18BD6F'  
                        }  
                    }
				}]
			});
			window.addEventListener("resize", function() {
				setTimeout(function() {
					myCje.resize();
				}, 0)
			});
		}
	},
	arthome:{
		ghua:function(xData,yData,echart,distribution){
			let myCjl = echart.init(document.getElementById('myCjl'));
			//定义年身分数据
			const xv = xData;
			var num=0;
			if(xv.length<=9){
				num =15;
			}
			if(xv.length>9 && xv.length<=20){
				num =75;
			}
			if(xv.length>20){
				num =85;
			}
			//console.log(xv,num,"年的数据444")
			//定义实际数据
			const yd = yData
			setTimeout(function() {
				myCjl.resize();
			}, 0)
			myCjl.setOption({
				/* title: {
					text: '成交拍品分布123',
					textStyle: {
						fontSize: 18
					}
				}, */
				tooltip: {
					"trigger": "axis",
					"triggerOn": "click",
					formatter(params) {
					    const item = params[0];
					    return `
					            ${item.axisValueLabel}
					            ${formatNum(item.data)}点
					           `;
					 },
				},
				dataZoom: {
					show: true,
					realtime: true,
					y: 20,
					height: 20,
					start:num,
					end:100,
					zoomLock:true
				},
				grid: {
					x: 65, //默认是80px
					y: 60, //默认是60px
					x2: 0, //默认80px
					y2: 30, //默认60px
					bottom: '14%'
				},
				xAxis: {
					type: 'category',
					data: xv,
					axisTick: {
						length: 10
					},
					axisLabel: {
						interval: 0,
						rotate: 40
					}
				},
				yAxis: {
					type: 'value',
					interval:distribution.distribution,
					min:distribution.min,
					max:distribution.max,
				},
				series: [{
					data: yd,
					type: 'line',
					itemStyle : {  
                        normal : {  
                            color:'#18BD6F'  
                        }  
                    }
				}]
			});
			window.addEventListener("resize", function() {
				setTimeout(function() {
					myCjl.resize();
				}, 0)
			});
		},
		youhua:function(xData,yData,echart,distribution){
			let myCje = echart.init(document.getElementById('myCje'));
			//定义年身分数据
			const xv = xData;
			//定义实际数据
			const yd = yData;
			//console.log(yd)
			myCje.setOption({
				/* title: {
					text: '成交拍品分布456',
					textStyle: {
						fontSize: 18
					}
				}, */
				tooltip: {
					"trigger": "axis",
					"triggerOn": "click",
					formatter(params) {
					    const item = params[0];
					    return `
					            ${item.axisValueLabel} 
					              ${formatNum(item.data)}点
					           `;
					 },
				},
				dataZoom: {
					show: true,
					realtime: true,
					y: 20,
					height: 20,
					start: 70,
					end: 100,
					zoomLock:true
				},
				grid: {
					x: 60, //默认是80px
					y: 60, //默认是60px
					x2: 0, //默认80px
					y2: 30,
					bottom: '14%' //默认60px
				},
				xAxis: {
					type: 'category',
					boundaryGap : false,
					data: xv,
					axisTick: {
						length: 10
					},
					axisLabel: {
						interval: 0,
						rotate: 40
					}
				},
				yAxis: {
					type: 'value',
					interval:distribution.distribution,
					min:distribution.min,
					max:distribution.max,
				},
				series: [{
					data: yd,
					type: 'line',
					itemStyle : {  
                        normal : {  
                            color:'#18BD6F'  
                        }  
                    }
				}]
			});
			window.addEventListener("resize", function() {
				setTimeout(function() {
					myCje.resize();
				}, 0)
			});
		},
		myC:function(xData,yData,echart,distribution){
			let myC = echart.init(document.getElementById('myC'));
			//定义年身分数据
			const xv = xData;
			//定义实际数据
			const yd = yData;
			setTimeout(function() {
				myC.resize();
			}, 0)
			myC.setOption({
				/* title: {
					text: '成交拍品分布123',
					textStyle: {
						fontSize: 18
					}
				}, */
				tooltip: {
					"trigger": "axis",
					"triggerOn": "click",
					formatter(params) {
					    const item = params[0];
					    return `
					            ${item.axisValueLabel}
					            第：${formatNum(item.data)}名
					           `;
					 },
				},
				dataZoom: {
					show: true,
					realtime: true,
					y: 20,
					height: 20,
					start: 70,
					end: 100,
					zoomLock:true
				},
				grid: {
					x: 40, //默认是80px
					y: 60, //默认是60px
					x2: 0, //默认80px
					y2: 20, //默认60px
					bottom: '13%'
				},
				xAxis: {
					type: 'category',
					data: xv,
					axisTick: {
						length: 10
					},
					axisLabel: {
						interval: 0,
						rotate: 40
					}
				},
				yAxis: {
					type: 'value',
					interval:distribution.distribution,
					min:distribution.min,
					max:distribution.max,
					inverse: true
				},
				series: [{
					data: yd,
					type: 'line',
					itemStyle : {  
                        normal : {  
                            color:'#18BD6F'  
                        }  
                    }
				}]
			});
			window.addEventListener("resize", function() {
				setTimeout(function() {
					myC.resize();
				}, 0)
			});
		}
	}
}
export default{
	Econfig
}